import { render, staticRenderFns } from "./CommandAssignment.vue?vue&type=template&id=1d6ee2bf&"
import script from "./CommandAssignment.vue?vue&type=script&lang=js&"
export * from "./CommandAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports